function checkAndSendEmail({ state, output, services }) {
  let email = state.get('login.recovery.forgot.email.value')
  services.Http
    .post('/api/user/create/token', { email: email })
    .then(output.success)
    .catch(output.error)
}

checkAndSendEmail.async = true
checkAndSendEmail.outputs = ['success', 'error']

export default checkAndSendEmail



// WEBPACK FOOTER //
// ./src/modules/login/actions/checkAndSendEmail.js